import _ from "lodash";
import { createQS } from "../../utils";
import { API } from "aws-amplify";
import {
  CURRENT_SCROLL_POSITION,
  FETCH_USER_CHAT_SKILL_HISTORY,
  KEEP_SCROLL_POSITION,
  UPDATE_ALL_TIME_CHAT_USER_HISTORY,
  UPDATE_BUBBLE_RESPONSE,
  UPDATE_CHAT_BOUNDS,
  UPDATE_CHAT_OPEN_STATE,
  UPDATE_CHAT_POSITION,
  UPDATE_CHAT_SIZE,
  WELCOME_MESSAGE_SENT,
  SHOW_CHATBOT
} from "./types";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

const API_REQUEST_FIXED_PARAMS = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const fetchUserSkillHistory = initialLoad => async (dispatch, getState) => {
  const state = getState();
  let from = state.chat.chatUserHistory !== undefined ? state.chat.chatUserHistory.from : 0;
  let data = {
    queryStringParameters: {
      ApiCall: "chat.history",
      QueryData: createQS({
        from: from,
        tenant: state.auth.cognitoUser.attributes["custom:tenant"],
        user_id: state.auth.cognitoUser.attributes["sub"],
        source: "portal-responsum"
      })
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.idToken.jwtToken
    }
  };
  const response = await API.get(config.AWS_API_NAME, "chat/history", data);

  if (response.statusCode === 200) {
    dispatch({
      type: FETCH_USER_CHAT_SKILL_HISTORY,
      payload: _.extend({}, { data: response.data, from: from + 10 }, { initialLoad: initialLoad ? true : false })
    });
  }
};

export const keepScrollPosition = position => async (dispatch, getState) => {
  dispatch({
    type: KEEP_SCROLL_POSITION,
    payload: position
  });
};

export const updateCurrentScrollPosition = position => async (dispatch, getState) => {
  dispatch({
    type: CURRENT_SCROLL_POSITION,
    payload: position
  });
};

export const updateChatVisibility = visible => async (dispatch, getState) => {
  const state = getState();
  const username = state.auth.cognitoUser.username;
  dispatch({
    type: UPDATE_CHAT_OPEN_STATE,
    payload: { visible: visible, username: username }
  });
};

export const updateAllTimeUserHistory = history => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_ALL_TIME_CHAT_USER_HISTORY,
    payload: history
  });
};

export const updateChatSize = size => async (dispatch, getState) => {
  const state = getState();
  const username = state.auth.cognitoUser.username;
  dispatch({
    type: UPDATE_CHAT_SIZE,
    payload: { size: size, username: username }
  });
};

export const updateChatPosition = position => async (dispatch, getState) => {
  const state = getState();
  const username = state.auth.cognitoUser.username;
  dispatch({
    type: UPDATE_CHAT_POSITION,
    payload: { position: position, username: username }
  });
};

export const updateChatBounds = chatBounds => async (dispatch, getState) => {
  const state = getState();
  const username = state.auth.cognitoUser.username;
  dispatch({
    type: UPDATE_CHAT_BOUNDS,
    payload: { bounds: chatBounds, username: username }
  });
};

export const welcomeMessageSent = flag => async (dispatch, getState) => {
  dispatch({
    type: WELCOME_MESSAGE_SENT,
    payload: flag
  });
};

export const updateBubbles = bubbles => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_BUBBLE_RESPONSE,
    payload: bubbles
  });
};

export const showChatbot = flag => async (dispatch, getState) => {
  dispatch({
    type: SHOW_CHATBOT,
    payload: flag
  });
};
